import styled from 'styled-components';
import NonProfitsCtaImage from '../../../assests/images/about-great-non-profit-image/non-profits-cta-box.webp';

export const AboutGreatNonprofitSection = styled.section`
    width: 100%;

    .about-great-nonprofit-banner{  
        @media screen and (max-width: 1024px){
            padding: 170px 0px 50px;
        }
    }

    .row {
        align-items: center;
    }
    .search-header{ 
        display:none;
    }
    p {
        padding-bottom: 25px;
        &:last-child{
            padding-bottom: 0px;
        }
    }
    .about-great-title{
        max-width: 439px;
        color:#333333;
        font-family: "Jost", sans-serif;
        font-size:30px;
        font-weight: 600;
        line-height: 45px;

        @media screen and (max-width: 991px){
            max-width: inherit;
        }
  
    }
    .about-great-text{
        max-width: inherit;
    }
    .quote_col{
        display:block;
    }
    .btn-outline-success-blue {
        padding: 12px 39px;
    }

    .about-img-profit{
        padding:0;
        @media screen and (max-width: 575px){
            row-gap: 10px;
            display: flex;
            flex-direction: column;
        }
    }
    .left_banner{
        padding-left: 100px;

        @media screen and (max-width: 575px){
            padding-left: 0px;
        }

    }
`;

export const EndorsementsSection = styled.section`
    width: 100%;
    background: #F1FEFF;
    padding: 50px 0;

    @media screen and (max-width: 575px){
        padding: 10px 0 40px;
    }
`;
export const AboutQuote = styled.div`
    position: absolute;
    width: 179px;
    left: -114px;
    
    @media screen and (max-width: 991px){
        left: -90px;
    }

    @media screen and (max-width: 575px){
        width: 100%;    
        left: inherit;
        position: inherit;
    }
`;
export const AboutBottom = styled.div`
    position: absolute;
    width: 282px;
    left: -114px;
    bottom: 0;

    @media screen and (max-width: 1024px){
        left: -100px;
    }
    
    @media screen and (max-width: 991px){
        left: -90px;
    }

    @media screen and (max-width: 575px){
        width: 100%;    
        left: inherit;
        position: inherit;
    }
`;

export const ClientLogoWrap = styled.div`
    width: 100%;
    background: #F1FEFF;
    padding: 40px 0px;
    display: flex;
    flex-wrap: wrap;
    gap: 30px 39px;

    @media screen and (max-width: 575px){
        padding: 40px 0px;
        gap: 25px;
    }
`;

export const ClientLogoBox = styled.div`
    width: 20%;
    display: flex;
    justify-content: center;
    align-items: center;
    img{
        width: 100%;
    }
`;

export const ClientBgImage = styled.div`
    width: 100%;
    max-width: 552px;
    background: #FFFFFF;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
    border-radius: 15px;
    overflow: hidden;
    margin-left: 36px;
    box-shadow: 0px 20px 20px #0000001A;

    
    @media screen and (max-width: 1200px){
        max-width: 100%;
        margin-left: 0px;
    }

    img{
        width: 100%;
        height: 100%;
        display: block;
        border-radius: 10px;
    }
`;

export const EndorsementsClientWrap = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    column-gap: 24px;
    margin-top: -268px;

    @media screen and (max-width: 1024px){
        gap: 15px;
        flex-wrap: wrap;
    }
`;

export const EndorsementsClientButton = styled.div`
    width: 100%;
    display:flex;
    justify-content: flex-end;
    align-items: flex-end;
    margin-top: 71px;
   .btn-outline-success-blue{
       padding: 12px 45px;
       }
    @media screen and (max-width: 991px){
        margin-top: 50px;
        justify-content: center;
        align-items: center;
    }

     @media screen and (max-width: 767px){
         margin-top: 40px;
     }
    
    a{
        text-decoration: none;
        margin-bottom: 60px;

        &.btn-outline-success-blue{
            padding: 12px 45px;

            @media screen and (max-width: 767px){
                padding: 12px 30px;
            }
        }
    }
`;

export const EndorsementsClientBox = styled.div`
    width: calc(33.33% - 14px);
    max-width: 282px;
    padding: 20px;
    display: flex;
    background: #FFFFFF;
    border-radius: 15px;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    text-align: center;
    row-gap: 24px;
    box-shadow: 0px 5px 30px #0000001A;

    @media screen and (max-width: 991px){
       padding: 15px;
        row-gap: 20px;
    }
    @media screen and (max-width: 767px){
        width: 100%;
        max-width: inherit;
    }
`;

export const EndorsementsClientImageBox = styled.div`
    width: 100%;
`;

export const EndorsementsClientImage = styled.div`
    max-width: 120px;
    max-height: 120px;
    display: block;
    margin: 0 auto;
    border-radius: 15px;
    overflow: hidden;
    margin-bottom: 20px;
    img{
        width: 100%;
        height: 100%;
        display: block;
        object-fit: cover;
    }
`;

export const EndorsementsClientText = styled.div`
    max-width: 210px;
    margin: 0 auto;
    text-align: center;
    font-size: 18px;
    font-family: 'Jost', sans-serif;
    font-weight: 500;
    line-height: 26px;
    color: #333333;
     
    @media screen and (max-width: 767px){
        max-width: 100%;
    }
`;

export const EndorsementsClientName = styled.div`
    width: 100%;
    text-align: center;
`;

export const EndorsementsClientSubTitle = styled.h3`
    color: #01606F;
    font-size: 20px;
    font-family: 'Jost', sans-serif;
    font-weight: 700;
    line-height: 30px;
    margin-bottom: 3px;
`;

export const EndorsementsClientDesignation = styled.div`
    color: #000000;
    font-size: 14px;
    font-family: 'Jost', sans-serif;
    font-weight: 400;
    line-height: 20px;
    min-height: 40px;
`;

export const NonProfitsCta = styled.section`
    width: 100%;
    background: #F1FEFF;
    padding: 0px 0px 70px;

    @media screen and (max-width: 991px){
        padding: 0px 0px 50px;
    }

    @media screen and (max-width: 575px){
        padding: 0px 0px 40px;
    }
`;

export const NonProfitsCtaBox = styled.div`
    width: 100%;
    min-height: 458px;
    background: #F1FEFF;
    color: #FFFFFF;
    font-size: 14px;
    font-family: 'Jost', sans-serif;
    font-weight: 400;
    line-height: 20px;
    padding: 10px;
    border-radius: 15px;
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    row-gap: 15px;
    box-shadow: 0px 20px 20px #0000001A;

    @media screen and (max-width: 767px){
        min-height: inherit;
        padding: 50px 10px;
    }
    
    @media screen and (max-width: 575px){
        min-height: 100%;
        padding: 30px;
    }

    &::before{
        content: '';
        position: absolute;
        background-image:url(${NonProfitsCtaImage});
        width: calc(100% - 20px);
        height: calc(100% - 20px);
        left: 10px;
        right: 10px;
        top: 10px;
        bottom: 10px;
        margin: auto;
        border-radius: 10px;
    }
    &::after{
        content: '';
        position: absolute;
        background: rgb(0 0 0 / 80%);
        width: calc(100% - 20px);
        height: calc(100% - 20px);
        left: 10px;
        right: 10px;
        top: 10px;
        bottom: 10px;
        margin: auto;
        border-radius: 10px;
    }
`;

export const NonProfitsCtaBoxTitle = styled.h2`
    width: 100%;
    max-width: 825px;
    margin: 0 auto; 
    color: #FFFFFF;
    font-size: 30px;
    font-family: 'Jost', sans-serif;
    font-weight: 700;
    line-height: 44px;
    text-align: center;
    position: relative;
    z-index: 1;

    @media screen and (max-width: 991px){
        font-size: 28px;
        line-height: 40px;
    }

    @media screen and (max-width: 767px){
        font-size: 26px;
        line-height: 38px;
        max-width: inherit;
        padding: 0px 40px;
    }

    @media screen and (max-width: 575px){
        font-size: 24px;
        line-height: 36px;
    }

    @media screen and (max-width: 480px){
        font-size: 20px;
        line-height: 30px;
        padding: 0px
    }
`;

export const NonProfitsCtaBoxText = styled.p`
    width: 100%;
    max-width: 804px;
    margin: 0 auto;
    text-align: center;
    position: relative;
    z-index: 1;
    
    @media screen and (max-width: 991px){
         max-width: 400px;
    }
`;

export const InspiringInformingSection = styled.section`
    width: 100%;
    background: #F1FEFF;
    padding-bottom: 70px;

    @media screen and (max-width: 991px){
        padding-bottom: 50px;
    }
        
    @media screen and (max-width: 575px){
        padding-bottom: 40px;
    }

    .inspiring-informing-group{
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 70px;

        @media screen and (max-width: 991px){
            margin-bottom: 50px;
        }
        
        @media screen and (max-width: 575px){
            margin-bottom: 40px;
        }
    }
`;

export const InspiringInformingImage = styled.div`
    width: 100%;
    max-width: 548px;
    margin: 0 auto;
    background: #fff;
    padding:20px;

    @media screen and (max-width: 767px){
        max-width: 400px;
    }

    img{
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
    }
`;

export const InspiringInformingWrap = styled.div`
    width: 100%;
    padding-left: 24px;
    color: #333333;
    font-size: 18px;
    font-family: 'Jost', sans-serif;
    font-weight: 400;
    line-height: 26px;
    @media screen and (max-width: 991px){
        text-align: center;
        padding-left: 24px;
    }
`;

export const InspiringInformingTitle = styled.h2`
    width: 100%;
    color: #333;
    font-size: 30px;
    font-family: 'Jost', sans-serif;
    font-weight: 700;
    line-height: 44px;
    margin-bottom: 25px;

    @media screen and (max-width: 991px){
        font-size: 28px;
        line-height: 40px;
        margin-bottom: 20px;
    }

    @media screen and (max-width: 767px){
        font-size: 26px;
        line-height: 38px;
        margin-bottom: 15px;
    }

    @media screen and (max-width: 575px){
        font-size: 24px;
        line-height: 36px;
        margin-bottom: 15px;
    }
`;

export const InspiringInformingText = styled.p`
    width: 100%;
    margin: 0px;
`;

export const InspiringInformingButton = styled.div`
    margin-top: 42px;

    @media screen and (max-width: 991px){
        margin-top: 30px;
    }
    a{
        text-decoration: none;
    }
    .btn-outline-success-blue {
        padding: 12px 30px !important;
    }
`;

export const InspiringInformingDonorsWrap = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    column-gap: 24px;

    @media screen and (max-width: 991px){ 
        align-items: flex-start;
        flex-direction: column;
        row-gap: 30px;
    }
`;

export const InspiringInformingDonors = styled.div`
    width: calc(50% - 10px);
    background: #FFFFFF;
    border-radius: 20px;
    box-shadow: 0px 5px 30px #0000001A;

    @media screen and (max-width: 991px){
        width: 100%;
    }
`;

export const InspiringDonorsImage = styled.div`
    width: 100%;
    height:100%;
    max-height: 360px;
    display: block;
    border-radius: 20px;
    overflow: hidden;

    @media screen and (max-width: 1200px){ 
        max-height: 300px;
        border-radius: 20px;
    }

    @media screen and (max-width: 991px){
        width: inherit;
    }

    img{
        width: 100%;
        height:100%;
        object-fit: cover;
        display: block;
    }
`;

export const InspiringDonorsContent = styled.div`
    width: 100%;
    padding: 30px;
    color: #333333;
    font-size: 18px;
    font=family: "Jost", sans-serif;
    font-weight: 500;
    line-height: 26px;

    @media screen and (max-width: 575px){
       padding: 20px;
    }

`;


export const InspiringDonorsSubTitle = styled.h3`
    color: #01606F;
    font-size: 20px;
    font=family: "Jost", sans-serif;
    font-weight: 700;
    line-height: 26px;
    margin-bottom: 12px;
`;

export const InspiringDonorsText = styled.p`
   margin: 0;
`;

export const SocialMediaSection = styled.section`
   width: 100%;
   background: #F1FEFF;
   padding-bottom: 78px;

    @media screen and (max-width: 991px){
        padding-bottom: 50px;
    }

    @media screen and (max-width: 575px){
        padding-bottom: 40px;
    }
`;

export const SocialMediaWrap = styled.div`
   width: 100%;
   background: rgb(51 167 174 / 10%);
   border-radius: 15px;
   padding: 35px 18px 35px 30px;
   display: flex;
   justify-content: flex-start;
   align-items: center;
   column-gap: 24px;

    @media screen and (max-width: 991px){
        padding: 25px;
        flex-direction: column-reverse;
        justify-content: center;
        row-gap: 40px;
    }
`;

export const SocialMediaContent = styled.div`
    width: 50%;
    display: flex;
    flex-direction: column;
    
    @media screen and (max-width: 991px){
        width: 100%;
        justify-content: center;
        align-items: center;
        text-align: center;
    }
`;

export const SocialMediaTitle = styled.h2`
    color: #01606F;
    font-size: 30px;
    font-family: 'Jost', sans-serif;
    font-weight: 700;
    line-height: 44px;
    
    @media screen and (max-width: 991px){
        font-size: 28px;
        line-height: 40px;
    }

    @media screen and (max-width: 767px){
        font-size: 26px;
        line-height: 38px;
    }

    @media screen and (max-width: 575px){
        font-size: 24px;
        line-height: 36px;
    }
`;  

export const SocialMediaIcon = styled.div`
    width: 100%;
    display: flex;
    gap: 16px;
    margin-top: 30px;

    @media screen and (max-width: 991px){
       justify-content: center;
    }

    .social-media-icon-bg{
        width: 60px;
        height: 60px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 10px;
        background: #3D5A98;

        @media screen and (max-width: 767px){
            width: 40px;
            height: 40px;
        }
        
        img{
            width: 20px;
            height: 100%;
            max-height 31px:
            display: block;

            @media screen and (max-width: 767px){
                width: 12px;
            }
        }

        &:nth-child(2){
            background: #000000;
            img{
                width: 30px;
                max-height 25px:
                @media screen and (max-width: 767px){
                    width: 24px;
                }
            }
        }

        &:nth-child(3){
            background: transparent linear-gradient(47deg, #E80012 0%, #E5001A 6%, #B600A7 100%) 0% 0% no-repeat padding-box;
            img{
                width: 25px;
                max-height 25px:
                @media screen and (max-width: 767px){
                    width: 20px;
                }
            }
        }

        &:nth-child(4){
            background: #0073B2;
            img{
                width: 25px;
                max-height 25px:
                @media screen and (max-width: 767px){
                    width: 20px;
                }
            }
        }
    }
`;

export const SocialMediaImage = styled.div`
    width: 50%;
    max-width: 558px;

    @media screen and (max-width: 991px){
        width: 100%;
        max-width: inherit;
    }

    img{
        width: 100%;
        display: block;
    }
`;

export const GreatNonprofitsTeamSection = styled.section`
    width: 100%;
    background: #F1FEFF;
`;

export const GreatNonprofitsTeamTopGroup = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 27px;

    @media screen and (max-width: 480px){
        flex-direction: column;
        row-gap: 15px;
    }
        
`;

export const GreatNonprofitsTeamTitle = styled.h2`
    color: #333333;
    font-size: 30px;
    font=family: "Jost", sans-serif;
    font-weight: 700;
    line-height: 44px;
    
    @media screen and (max-width: 991px){
        font-size: 28px;
        line-height: 40px;
    }

    @media screen and (max-width: 767px){
        font-size: 26px;
        line-height: 38px;
    }

    @media screen and (max-width: 575px){
        font-size: 24px;
        line-height: 36px;
    }
`;

export const GreatNonprofitsTeamButton = styled.div`
    
    a{
        text-decoration: none;
        margin-bottom: 0px;

        &.btn-outline-success-blue{
            padding: 12px 45px;
        }
    }
    .btn-outline-success-blue {
        padding: 12px 58px;

        @media screen and (max-width: 575px){
            padding: 12px 20px;
        }
    }
`;

export const TeamMemberWrap = styled.div`
    width: 100%;
    background: #01606F;
    padding: 10px;
    border-radius: 10px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    column-gap: 20px;
    margin-bottom: 50px;

    @media screen and (max-width: 575px){
        margin-bottom: 40px;
        flex-direction: column;
        row-gap: 20px;
        padding: 20px;
    }
`;

export const TeamMemberImage = styled.div`
    max-width: 262px;
    height: 262px;
    border-radius: 10px; 
    overflow: hidden;
     width: 100%;
    img{
        width: 100%;
        height: 100%;
        display: block;
          border-radius: 10px; 
    }
`;

export const TeamMemberContent = styled.div`
    max-width: 880px;
    color: #fff;
    font-size: 18px;
    font-family: 'Jost', sans-serif;
    font-weight: 500;
    line-height: 26px;
`;

export const TeamMemberName = styled.div`
    font-size: 20px;
    font-family: 'Jost', sans-serif;
    font-weight: 700;
    line-height: 30px;
    margin-bottom: 5px;
`;

export const TeamMemberDesignation = styled.div`
    font-size: 14px;
    font-family: 'Jost', sans-serif;
    font-weight: 400;
    line-height: 20px;
    margin-bottom: 20px;
`;

export const TeamMemberText = styled.div`
    margin: 0;
`;

export const TeamMemberTextStrong = styled.div`
    font-weight: 700;
    display: inline;
`;

export const BoardMemberSection = styled.section`
    width: 100%;
    background: #F1FEFF;
    padding-bottom: 50px;

    @media screen and (max-width: 575px){
        padding-bottom: 40px;
    }
`;


export const ProjectMadeSection = styled.section`
    width: 100%;
    background: #F1FEFF;
    padding-bottom: 50px;

    @media screen and (max-width: 575px){
        padding-bottom: 40px;
    }
`;

export const ProjectMadeWrap = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    text-align: center;
`;

export const ProjectMadeTitle = styled.h2`
    width: 100%;
    color: #333;
    font-size: 30px;
    font-family: 'Jost', sans-serif;
    font-weight: 700;
    line-height: 44px;
    margin-bottom: 32px;

    @media screen and (max-width: 991px){
        font-size: 28px;
        line-height: 40px;
    }

    @media screen and (max-width: 767px){
        font-size: 26px;
        line-height: 38px;
    }

    @media screen and (max-width: 575px){
        font-size: 24px;
        line-height: 36px;
    }
`;

export const ProjectMadeLogoWrap = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    column-gap: 30px;

    @media screen and (max-width: 575px){
        flex-wrap: wrap;
        gap: 30px 20px;
    }
`;

export const ProjectMadeLogoBox = styled.div`
    width: max-content;
    
    @media screen and (max-width: 480px){
        max-width: 125px;
    }

    img{
        display: block; 

        @media screen and (max-width: 480px){
            width: 100%;
        }
    }
`;

export const AdvisoryBoardGroup = styled.div`
    display: flex;
    gap: 30px;
    flex-wrap: wrap;
    
    @media screen and (max-width: 991px){
        gap: 20px;
    }
    
    .board-member-box {
        background: #33A7AE;
    }
    .member-name{
        color: #01606F;
    }
`;

export const BoardMembersBox = styled.div`
    display: flex;
    gap: 30px;
    flex-wrap: wrap;
    
    @media screen and (max-width: 991px){
        gap: 20px;
    }
`;

